import { rem } from 'polished';
import styled from '../../../styles/theme';
import ModalTiresDetailTemplate from './ModalTiresDetailTemplate';

export const ModalTiresDetailStyled = styled(ModalTiresDetailTemplate)`
    .tires-detail {
        &__label,
        &__subtitle,
        &__description {
            color: ${({ theme }) => theme.colors.black};
        }

        &__image {
            display: block;
        }

        &__label {
            font-size: ${rem(12)};
            text-transform: uppercase;
        }

        &__link {
            svg {
                width: ${rem(20)};
                height: ${rem(12)};

                path {
                    fill: ${({ theme }) => theme.colors.primary};
                }
            }
        }
    }
`;
